import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { AdnCargoTankType } from "view/ships/types/ship";

const AdnCargoTankTypeSelect = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return (
		<Select
			disableSearch
			fetchOptions={Object.keys(AdnCargoTankType)}
			getOptionLabel={opt => `${opt}. ${AdnCargoTankType[opt as keyof typeof AdnCargoTankType]}`}
			multiple={false}
			value={value}
			onChange={onChange}
		/>
	);
};

export default AdnCargoTankTypeSelect;
